import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=a486d2d8&"
import script from "./Boards.vue?vue&type=script&lang=ts&"
export * from "./Boards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports